<template>
  <div class="modify-password-container">
    <a-modal
      wrapClassName="modify-password-modal"
      :visible="true"
      :closable="true"
      title="修改密码"
      @cancel="handleCancel"
      :footer="null"
      :maskClosable="false"
    >
      <!-- 设置类型 -->
      <a-tabs v-model:activeKey="modifyType" @change="tabChange">
        <a-tab-pane key="password" tab="密码验证"></a-tab-pane>
        <a-tab-pane key="phone" tab="手机验证"></a-tab-pane>
      </a-tabs>
      <a-alert
        message="为了确保账户安全，请先验证您的旧密码后继续"
        type="warning"
        show-icon
        style="margin-bottom: 32px"
      />
      <!-- <a-form-model :layout="'inline'">
        <a-form-model-item label="Field A">
          <a-input  placeholder="input placeholder" />
        </a-form-model-item>
    </a-form-model> -->
      <!-- 修改密码表单 -->
      <a-form-model
        class="modify-password-form"
        ref="formRef"
        :model="form"
        :rules="rules"
        layout="horizontal"
        v-bind="formItemLayout"
      >
        <!-- 密码修改 -->
        <template v-if="modifyType === 'password'">
          <a-form-model-item label="验证旧密码" prop="oldPwd">
            <a-input-password
              placeholder="请输入旧密码"
              v-model="form.oldPwd"
              autocomplete="new-password"
              tabindex="1"
              @change="oldPswChange"
            ></a-input-password>
            <div v-if="olePswStatus == 0" class="checkOldPsw" @click="checkPsw">
              验证
            </div>
            <div v-if="olePswStatus == 1" class="checkOldPsw checkOldPswRight">
              <img src="./assets/right.svg" />验证通过
            </div>
            <div v-if="olePswStatus == 2" class="checkOldPsw checkOldPswWrong">
              {{ olePswErrorInfo }}
            </div>
          </a-form-model-item>
        </template>
        <!-- 手机号修改 -->
        <template v-if="modifyType === 'phone'">
          <a-form-model-item label="输入手机号" prop="phone">
            <a-input
              placeholder="请输入11纯数字"
              v-model="form.phone"
              :disabled="true"
            >
              <template #suffix>
                <span class="verify-code-text" @click.stop="getVerifyCode">
                  <a v-if="!timeShow">获取验证码</a>
                  <a v-else>已发送({{ timeCount }}S)</a>
                </span>
              </template>
            </a-input>
          </a-form-model-item>
          <a-form-model-item label="验证码" prop="verifyCode">
            <input
              style="opacity: 0; position: absolute; width: 0; height: 0"
            />
            <input
              type="password"
              style="opacity: 0; position: absolute; width: 0; height: 0"
            />
            <a-input
              placeholder="请输入6位纯数字"
              v-model="form.verifyCode"
              autocomplete="new-password"
              type="number"
              @blur="handleNumber"
              tabindex="1"
              @keydown="handleNumber"
            ></a-input>
          </a-form-model-item>
        </template>
        <!-- 设置新密码 -->
        <a-form-model-item label="输入新密码" prop="newPwd">
          <!-- <input
            autocomplete="off"
            style="opacity: 0; position: absolute; width: 0; height: 0"
          />
          <input
            type="password"
            autocomplete="off"
            style="opacity: 0; position: absolute; width: 0; height: 0"
          /> -->
          <a-tooltip
            trigger="click"
            overlayClassName="account-s-tooltip"
            :getPopupContainer="
              (triggerNode) => {
                return triggerNode.parentNode || document.body;
              }
            "
          >
            <template slot="title">
              <div class="warning-tip-con">
                <div class="warning-tip">
                  <i
                    class="warning-tip-icon"
                    :class="{
                      'warning-tip-len-err-icon':
                        pwdRuleInfo.pwdLengthRule == 3,
                      'warning-tip-len-ok-icon': pwdRuleInfo.pwdLengthRule == 2,
                    }"
                  ></i>
                  <span class="warning-tip-content"
                    >长度为8-18个字符，密码不能和用户名相同</span
                  >
                </div>
                <div class="warning-tip">
                  <i
                    class="warning-tip-icon"
                    :class="{
                      'warning-tip-len-err-icon': pwdRuleInfo.pwdSpaceRule == 3,
                      'warning-tip-len-ok-icon': pwdRuleInfo.pwdSpaceRule == 2,
                    }"
                  ></i>
                  <span class="warning-tip-content"
                    >只能包含字母、数字以及特殊字符(除空格)</span
                  >
                </div>
                <div class="warning-tip">
                  <i
                    class="warning-tip-icon"
                    :class="{
                      'warning-tip-len-err-icon':
                        pwdRuleInfo.pwdContainTwoRule == 3,
                      'warning-tip-len-ok-icon':
                        pwdRuleInfo.pwdContainTwoRule == 2,
                    }"
                  ></i>
                  <span class="warning-tip-content"
                    >字母、数字和特殊字符至少包含{{ pwdCount }}种</span
                  >
                </div>
                <div class="warning-tip">
                  <i
                    class="warning-tip-icon"
                    :class="{
                      'warning-tip-len-err-icon': pwdRuleInfo.pwdSameRule == 3,
                      'warning-tip-len-ok-icon': pwdRuleInfo.pwdSameRule == 2,
                    }"
                  ></i>
                  <span class="warning-tip-content"
                    >新密码与旧密码至少有2位或以上字符位不同</span
                  >
                </div>
              </div>
            </template>
            <a-input-password
              :disabled="!canInputNewPsw"
              :placeholder="
                '支持8-18位字符，字符/数字/特殊字符符号至少包含' +
                pwdCount +
                '种'
              "
              v-model="form.newPwd"
              tabindex="2"
              autocomplete="new-password"
              @focus="handlePwdFocus(1)"
              @blur="handlePwdFocus(2)"
              @change="handlePwdChange"
            ></a-input-password>
          </a-tooltip>
        </a-form-model-item>

        <a-form-model-item label="再次输入新密码" prop="checkPwd">
          <!-- <input
            autocomplete="off"
            style="opacity: 0; position: absolute; width: 0; height: 0"
          />
          <input
            autocomplete="off"
            type="password"
            style="opacity: 0; position: absolute; width: 0; height: 0"
          /> -->
          <a-input-password
            :disabled="!canInputNewPsw"
            placeholder="请再次输入新密码"
            autocomplete="new-password"
            v-model="form.checkPwd"
            tabindex="3"
          ></a-input-password>
        </a-form-model-item>
      </a-form-model>

      <!-- 操作按钮 -->
      <a-row type="flex" justify="end" :gutter="20" class="operate-btn-group">
        <a-col>
          <a-button @click="handleCancel">取消</a-button>
        </a-col>
        <a-col>
          <a-button type="primary" @click="handleOk">确认</a-button>
        </a-col>
      </a-row>
      <msgPop ref="msgPopContent"></msgPop>
    </a-modal>
  </div>
</template>

<script>
import {
  modifyPwd as modifyPwdApi,
  getVerifyCode as getVerifyCodeApi,
  queryPwdCount,
  oldPwdCheck,
  newPwdCheck,
  codeVerify
} from "@/api/personal.js";
import { checkPwd, handleOnlyNumber, isChinese } from "@/utils";
import { setStore, getStore, removeStore } from "@/utils/storage";
import msgPop from "./component/msgPop/msgPop.vue";
export default {
  components: {
    msgPop
  },
  data() {
    return {
      modifyType: "password",
      olePswStatus: 0,
      canInputNewPsw: false,
      olePswErrorInfo:'',
      codeErrorInfo:'',
      codeVerifyStatus:false,
      form: {
        oldPwd: "",
        newPwd: "",
        checkPwd: "",
        phone: "",
        verifyCode: "",
      },
      pwdRuleInfo: {
        pwdLengthRule: 1, // 1：默认状态 2: 验证通过 3:验证错误
        pwdSpaceRule: 1, // 1：默认状态 2: 验证通过 3:验证错误
        pwdContainTwoRule: 1, // 1：默认状态 2: 验证通过 3:验证错误
        pwdSameRule: 1, // 1：默认状态 2: 验证通过 3:验证错误
      },
      pwdCount: 2,
      pwdFocus: false,
      rules: {
        oldPwd: [
          { required: true, message: "旧密码必须填写" },
          // {
          //   validator: (rule, value, callback) => {
          //     if (/[\s\u4E00-\u9FA5]+/.test(value)) {
          //       return Promise.reject(new Error("支持大小写英文/数字/符号"));
          //     } else {
          //       return Promise.resolve()
          //     }
          //   },
          //   trigger: "blur",
          // },
          // { min: 8, max: 15, message: "格式错误，请输入8-18位的字符", trigger: "blur " },
        ],
        phone: [
          { required: true, message: "手机号码必须填写" },
          {
            validator: (rule, value, callback) => {
              if (/^1\d{10}$/.test(value)) {
                return Promise.resolve();
              } else {
                return Promise.reject(new Error("请输入11位纯数字号码"));
              }
            },
            trigger: "blur",
          },
        ],
        verifyCode: [
          { required: true, message: "验证码必须填写" },
          {
            validator: (rule, value) => {

              if (/^\d{6}$/.test(value)) {
              } else{
                return Promise.reject(new Error("请输入6位纯数字验证码"));
              }

              if (this.codeVerifyStatus) {
              } else{
                return Promise.reject(new Error(this.codeErrorInfo));
              }

              return Promise.resolve();
            },
            trigger: "blur",
          },
        ],
        newPwd: [
          { required: true, message: "新密码必须填写" },
          {
            validator: (rule, value, callback) => {
              if (!checkPwd(value, this.pwdCount)) {
                return Promise.reject(new Error("密码格式错误"));
              } else {
                return Promise.resolve();
              }
            },
          },
          { min: 8, max: 18, message: "密码格式错误", trigger: "blur" },
        ],
        checkPwd: [
          { required: true, message: "确认密码必须填写" },
          {
            validator: (rule, value, callback) => {
              let { newPwd } = this.form;
              if (value !== newPwd) {
                return Promise.reject(
                  new Error("两次输入密码不一致，请重新输入")
                );
              } else {
                return Promise.resolve();
              }
            },
            trigger: "blur",
          },
        ],
      },
      // 验证码
      timeShow: false,
      timeCount: 60,
      timer: null,
    };
  },
  mounted() {
    let userInfo = JSON.parse(getStore("userInfo"));
    this.form.phone = userInfo.phone;
    this.fetchPwdCount();
  },
  methods: {
    async fetchPwdCount() {
      try {
        const { code, result } = await queryPwdCount();
        if (code === 1000) {
          this.pwdCount = result == "REGEX_PWD2" ? 3 : 2;
        }
      } catch (error) {}
    },
    handlePwdChange() {
      if (this.form.newPwd) {
        // 字符长度校验
        // 验证通过
        if (
          this.form.newPwd.length >= 8 &&
          this.form.newPwd.length <= 18 &&
          this.form.newPwd != JSON.parse(getStore("userInfo")).name
        ) {
          this.pwdRuleInfo.pwdLengthRule = 2;
        } else {
          // 验证不通过
          this.pwdRuleInfo.pwdLengthRule = 3;
        }

        if (!isChinese(this.form.newPwd)) {
          // 验证通过
          this.pwdRuleInfo.pwdSpaceRule = 2;
        } else {
          // 验证不通过
          this.pwdRuleInfo.pwdSpaceRule = 3;
        }
        // 验证数字+字母+特殊字符(两两组合)
        if (checkPwd(this.form.newPwd, this.pwdCount)) {
          // 验证通过
          this.pwdRuleInfo.pwdContainTwoRule = 2;
        } else {
          // 验证不通过
          this.pwdRuleInfo.pwdContainTwoRule = 3;
        }

        if (this.modifyType == "password") {
          if (this.checkPwdSame(this.form.newPwd, this.form.oldPwd)) {
            this.pwdRuleInfo.pwdSameRule = 2;
          } else {
            this.pwdRuleInfo.pwdSameRule = 3;
          }
        }
        if (this.modifyType == "phone") {
          let data = {
            pwd:this.form.newPwd
          }
          newPwdCheck(data).then((res) => {
            if (res.code === 1000) {
              if(res.state == true ){
                this.pwdRuleInfo.pwdSameRule = 2;
              }else{
                this.pwdRuleInfo.pwdSameRule = 3;
              }
            } else {
              this.pwdRuleInfo.pwdSameRule = 3;
            }
          });
          
        }
      } else {
        this.pwdRuleInfo.pwdLengthRule = 1;
        this.pwdRuleInfo.pwdSpaceRule = 1;
        this.pwdRuleInfo.pwdContainTwoRule = 1;
        this.pwdRuleInfo.pwdSameRule = 1;
      }
    },
    checkPwdSame(value, oleValue) {
      value = value + "";
      oleValue = oleValue + "";
      let num = 0;
      let value1 = "";
      let value2 = "";
      if (value.length > oleValue.length) {
        value1 = value;
        value2 = oleValue;
      } else {
        value1 = oleValue;
        value2 = value;
      }
      for (let i = 0; i < value1.length; i++) {
        if (value2[i] && value2[i] != value1[i]) {
          num++;
        } else {
          if (!value2[i]) {
            num++;
          }
        }
      }

      if (num < 2) {
        return false;
      } else {
        return true;
      }
    },
    handlePwdFocus(flag) {
      if (flag === 1) {
        //处于焦点
        this.pwdFocus = true;
      } else {
        //失去焦点
        this.pwdFocus = false;
      }
    },
    handleNumber(evt) {
      handleOnlyNumber(evt);
    },
    getVerifyCode() {
      if (this.timeShow === true) return;
      this.$refs.formRef.validateField("phone", (errorMessage) => {
        if (errorMessage) return;

        let { phone } = this.form;
        // const { projectId } = JSON.parse(localStorage.getItem("projectInfo"));
        // 验证码获取时间间隔
        const MAX_COUNT = 60;
        this.timeCount = MAX_COUNT;
        this.timeShow = true;
        getVerifyCodeApi({
          phone,
          // projectId,
        })
          .then((res) => {
            if (res.code === 1000) {
              // 倒计时
              this.timer = setInterval(() => {
                if (this.timeCount > 0 && this.timeCount <= MAX_COUNT) {
                  this.timeCount--;
                } else {
                  this.timeShow = false;
                  clearInterval(this.timer);
                }
              }, 1000);
            } else {
              this.timeShow = false;
              this.$message.warning(res.message);
            }
          })
          .catch((err) => {
            this.timeShow = false;
            console.log("err", err);
          });
      });
    },
    async handleOk() {

      if(this.modifyType != "password"){
        let { phone, verifyCode } = this.form;
        let data = {
          msgCode:verifyCode,
          phone:phone
        }
        const { code, message, result ,state} = await codeVerify(data);
        if(!state){
          this.codeVerifyStatus = false
          this.codeErrorInfo = message
        }else{
          this.codeVerifyStatus = true
        }

        if(code == 9930 || code == 9920){
          removeStore('privateAccessToken')
          sessionStorage.removeItem('subCode')
          this.$refs.msgPopContent.labMsg = '账户安全提示';
          this.$refs.msgPopContent.comsShow = true;
          this.$refs.msgPopContent.content = '由于您的账户多次验证失败，账户已锁定，请于10分钟后重新登录';
          this.$refs.msgPopContent.iconType = 2;
          this.$refs.msgPopContent.btnList = [
            {
              name: '确认',
              type: "primary",
              fn: ()=>{
                this.$store.dispatch("logout");
              }
            }
          ];
        }
      }
        
      // 先验证验证码的正确性，然后再进行确定
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let { oldPwd, newPwd, phone, verifyCode } = this.form;
          modifyPwdApi({
            verifyType: this.modifyType === "password" ? 0 : 1,
            pwd: oldPwd,
            newPwd,
            phone,
            msgCode: verifyCode,
          }).then((res) => {
            console.log("res", res);
            if (res.code === 1000) {
              this.$message.success("修改成功");
              this.handleCancel();

              this.$store.dispatch("logout");
            } else {
              this.$message.warning({
                content: res.message,
              });
              if (res.code === 9930) {
                this.handleCancel();
                this.$store.dispatch("logout");
              }
            }
          });
        } else {
          this.$message.warning("信息填写不准确");
          return false;
        }
      });
    },
    handleCancel() {
      this.$emit("openModal", false);
    },
    toggleModifyType(value) {
      this.modifyType = value;
    },
    formItemLayout() {
      return {
        labelCol: { span: 4 },
        wrapperCol: { span: 14 },
      };
    },
    tabChange(){
      this.clearData()
      if(this.modifyType != 'password'){
        this.canInputNewPsw = true;
      }
      this.pwdRuleInfo.pwdLengthRule = 1;
      this.pwdRuleInfo.pwdSpaceRule = 1;
      this.pwdRuleInfo.pwdContainTwoRule = 1;
      this.pwdRuleInfo.pwdSameRule = 1;
    },
    oldPswChange() {
      this.clearData()
    },
    clearData(){
      this.olePswStatus = 0;
      this.canInputNewPsw = false;
      this.form.newPwd = "";
      this.form.checkPwd = "";
    },
    // 验证旧密码还是否正确
    checkPsw() {
      if (this.olePswStatus == 0) {
        let data = {
          pwd: this.form.oldPwd,
        };
        oldPwdCheck(data).then((res) => {
          console.log("res", res);
          if (res.code === 1000 && res.state == true) {
            this.olePswStatus = 1;
            this.canInputNewPsw = true;
          } else {
            this.olePswStatus = 2;
            this.canInputNewPsw = false;
            this.olePswErrorInfo = res.message
            if(res.code == 9930){
              removeStore('privateAccessToken')
              sessionStorage.removeItem('subCode')
              this.$refs.msgPopContent.labMsg = '账户安全提示';
              this.$refs.msgPopContent.comsShow = true;
              this.$refs.msgPopContent.content = '由于您的账户多次验证失败，账户已锁定，请于10分钟后重新登录';
              this.$refs.msgPopContent.iconType = 2;
              this.$refs.msgPopContent.btnList = [
                {
                  name: '确认',
                  type: "primary",
                  fn: ()=>{
                    this.$store.dispatch("logout");
                  }
                }
              ];
            }
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.warning-tip-con {
  padding: 8px 0;

  .warning-tip-content {
    color: #ffffff;
    font-size: 12px;
  }

  .warning-tip {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 4px;

    &-icon {
      width: 16px;
      height: 16px;
      margin-right: 8px;
      background: url("~@/assets/images/account/test-gt.svg") no-repeat center;
      background-size: 100%;
    }

    .warning-tip-len-err-icon {
      background: url("~@/assets/images/account/test-error.svg") no-repeat
        center;
    }

    .warning-tip-len-ok-icon {
      background: url("~@/assets/images/account/test-right.svg") no-repeat
        center;
    }
  }
}
.modify-password-container {
  .verify-code-text {
    color: @link-color;
    display: inline-block;
    height: 30px;
    line-height: 30px !important;
    color: @link-color;
    cursor: pointer;
  }
}
.checkOldPsw {
  color: #3370ff;
  cursor: pointer;
  //styleName: 字体/14Reg 文本;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
  vertical-align: middle;
  padding-left: 5px;
  img {
    width: 14px;
    height: 14px;
    margin-top: -3px;
    margin-right: 8px;
  }
}
.checkOldPswRight {
  color: #52c41a;
}
.checkOldPswWrong {
  color: #f5222d;
}
.operate-btn-group {
  margin-top: 100px;
}
.modify-password-modal {
  .house-modal-content {
    width: 492px;
  }
  .modify-password-types {
    margin-bottom: 24px;
    font-size: 14px;
    .modify-password-type {
      display: inline-block;
      line-height: 14px;
      padding: 0 10px;
      cursor: pointer;
      &.is-active {
        color: @primary-color;
        font-size: 18px;
      }
      &:first-child {
        padding-left: 0;
        border-right: 1px solid #ccc;
      }
    }
  }
}
</style>
<style lang="less">
.modify-password-modal {
  .house-modal-content {
    width: 492px;
    // height:717px;
  }
}
</style>
